module.exports = __webpack_public_path__ + "img/maneken_pos_2.5d4372fb.png";